import styled from '@emotion/styled';
import theme from '../../theme';
import { InputLabelProps } from './input-label.interfaces';

export const Label = styled('label')`
  @media (min-width: ${theme.breakpoints.values.sm}px) {
    display: block;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.1876em;
    margin-right: ${theme.spacing(1)};
    white-space: nowrap;
    min-width: 150px;
  }
  display: ${(props: InputLabelProps) => (props.hideOnSmallScreens && 'none') || 'block'};
`;
